import ProductTile from "./ProductTile";

const ProductTileContainer = props => <ProductTile {...props} />;

export default require("../../containers/withTogglePoint").default(ProductTileContainer, require.context("./__variants__/", true, /^\.\/([^/]+\/){2}ProductTileContainer\.js$/))
